var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AtomButton',{class:_vm.css(),attrs:{"size":_vm.size,"is-disabled":true,"on-click":function () {}}},[_c('MolInfoLock',{class:_vm.css('lock'),attrs:{"persistent-open":_vm.persistentOpen}},[_vm._t("lock-info")],2),_vm._t("button-text")],2)}
var staticRenderFns = []

export { render, staticRenderFns }